export default __webpack_public_path__ + "static/media/progress.b72b1a4f.svg";